import { connect } from 'react-redux'
import { selectors as backendSelectors } from '../../features/Backend'
import { selectors as syncSelectors } from '../../features/Sync'
import { selectors as steamSelectors } from '../../features/Steam'
import SideMenu from '../../components/SideMenu'
import localizeImport from '../../store/localize'
import getAttributes from '../../store/attributes'
import strings from '../../components/SideMenu/side-menu.json'
import { actionAppToggleShowSettingsState } from '../../actions'

function mapStateToProps(state) {
    const { app } = state
    const launcherType = backendSelectors.getLauncherType(state)
    const locale = backendSelectors.getLocale(state)
    const attributes = getAttributes(locale)

    // Launcher version checker
    // Figure out our current ui version, based on current launcher type
    const syncLauncherVersion = syncSelectors.getUiVersion(state)
    // Check if an update is currently available
    const updateAvailable = app.uiVersion !== '-1' && app.uiVersion !== syncLauncherVersion
    // Get search & hash
    const search = window.location.search
    const hash = window.location.hash
    // Set the new version path
    // < 2000 backwards compatibility included
    const newVersion =
        syncLauncherVersion < 2000
            ? `${syncLauncherVersion}/${search}${hash}`
            : `${launcherType}/${syncLauncherVersion}/${search}${hash}`

    // We don't want to show the twitch button att all in the chinese launcher
    const twitch = locale === 'zh' ? { streaming: false } : syncSelectors.getTwitchStatus(state)

    const localize = value => localizeImport(strings, locale, value)
    return {
        settingsOpen: app.showSettings,
        steamStartup: steamSelectors.isSteamStartup(state),
        twitch,
        newVersion,
        updateAvailable,
        locale,
        links: attributes.link,
        origin: attributes.launcher.origin,
        externalLinkText: localize('externalLink'),
        logoDescription: localize('logoDescription'),
        twitchText: localize('twitch'),
        updateTexts: {
            title: localize('updateTitle'),
            tooltip: localize('updateTooltip'),
            warning: localize('updateWarning'),
        },
        accountText: localize('account'),
        supportText: localize('support'),
        openSettingsText: localize('openSettings'),
        closeSettingsText: localize('closeSettings'),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        toggleSettings: () => {
            dispatch(actionAppToggleShowSettingsState())
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SideMenu)



// WEBPACK FOOTER //
// ./src/containers/SideMenu/side-menu.js